import Reveal from "@/components/base/Reveal";
import SectionHeading from "@/components/base/SectionHeading";
import ServiceCard from "@/pages/home/components/ServiceCard";
import { services } from "@/mocks/home";

export default function Services() {
  return (
    <section id="servicos" className="relative w-full bg-background-100 py-20 md:py-28">
      <div className="mx-auto w-full max-w-container px-4 md:px-6 lg:px-10">
        <SectionHeading
          eyebrow="Serviços"
          title="Tudo o que o seu condomínio precisa, num só lugar."
          description="Da administração financeira ao apoio jurídico, tratamos de cada detalhe para que os condóminos só tenham de se preocupar em viver bem."
        />

        <div className="mt-14 grid grid-cols-1 gap-5 sm:grid-cols-2 lg:grid-cols-4">
          {services.map((service, index) => (
            <Reveal key={service.title} delay={index * 90} className="h-full">
              <ServiceCard
                icon={service.icon}
                title={service.title}
                text={service.text}
                index={index}
              />
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  );
}